import React from 'react';
import EmptyImage from '../static/images/emptystate.png';

export default function NoNotificationPage({ isGlobal }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          margin: '0px 0px',
          padding: '0px 0px',
          height: '80px',
          width: '80px',
        }}
      >
        <img src={EmptyImage} alt="you have no notifications" />
      </div>
      <div
        style={{
          fontSize: '20px',
          fontWeight: '700',
          lineHeight: '26px',
          color: '#FFFFFF',
          margin: '16px 0 0 0',
        }}
      >
        {isGlobal ? 'No Notification' : 'ไม่มีการแจ้งเตือน'}
      </div>
      <div
        style={{
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '21px',
          color: '#B7B7B7',
          margin: '4px 0 0 0',
          textAlign: 'center',
        }}
      >
        {isGlobal
          ? 'We’ll let you know when there’s any news for you'
          : 'คุณจะถูกแจ้งให้ทราบเมื่อมีข่าวสารสำหรับคุณ'}
      </div>
    </div>
  );
}
